import React from "react";
import { RouteObject } from "react-router-dom";

import { ScopedRoute } from "@src/components/LimitAccess/ScopedRoute";

import { GENERAL_ROUTES } from "../../routes";

export const GeneralRoutes: RouteObject[] = [
  {
    path: GENERAL_ROUTES.ConfigHandler,
    lazy: async () => {
      const { ConfigHandler } = await import(
        "../../../domains/Settings/ConfigHandler"
      );
      return { element: <ConfigHandler /> };
    },
  },
  {
    path: GENERAL_ROUTES.Index,
    lazy: async () => {
      const { HomeDashboard } = await import("../../../domains/HomeDashboard");
      return { element: <HomeDashboard /> };
    },
  },
  {
    path: GENERAL_ROUTES.Home,
    lazy: async () => {
      const { HomeDashboard } = await import("../../../domains/HomeDashboard");
      return { element: <HomeDashboard /> };
    },
  },
  {
    path: GENERAL_ROUTES.Readme_Login,
    lazy: async () => {
      const { ReadMeLogin } = await import("../../../domains/ReadMe/login");
      return { element: <ReadMeLogin /> };
    },
  },
  {
    path: GENERAL_ROUTES.Logout,
    lazy: async () => {
      const { LogoutRedirect } = await import(
        "../../../domains/Redirects/LogoutRedirect"
      );
      return { element: <LogoutRedirect /> };
    },
  },
  // {
  //   path: GENERAL_ROUTES.IntelligemsAi,
  //   lazy: async () => {
  //     const { IntelligemsAi } = await import("../../../domains/IntelligemsAi");
  //     return { element: <IntelligemsAi /> };
  //   },
  // },
  {
    path: GENERAL_ROUTES.Performance,
    lazy: async () => {
      const { PerformanceRoute } = await import(
        "../../../domains/Performance/PerformanceRoute"
      );
      return { element: <PerformanceRoute /> };
    },
  },
  {
    path: GENERAL_ROUTES.Integrations,
    lazy: async () => {
      const { IntegrationsRoute } = await import(
        "../../../domains/Settings/Integrations"
      );
      return { element: <IntegrationsRoute /> };
    },
  },
  {
    path: GENERAL_ROUTES.GoogleIntegrationCallback,
    lazy: async () => {
      const { GoogleCallbackRoute } = await import(
        "../../../domains/Settings/Integrations/Google/GoogleCallback"
      );
      return { element: <GoogleCallbackRoute /> };
    },
  },
  {
    path: GENERAL_ROUTES.ConfigCompare,
    lazy: async () => {
      const { ConfigCompareDomain } = await import(
        "../../../domains/ConfigCompare"
      );
      return { element: <ConfigCompareDomain /> };
    },
  },
  {
    path: GENERAL_ROUTES.ManagePlans,
    lazy: async () => {
      const { ManagePlansDomain } = await import(
        "../../../domains/ManagePlans"
      );
      return { element: <ManagePlansDomain /> };
    },
  },
  {
    path: GENERAL_ROUTES.EventsManager,
    lazy: async () => {
      const { EventsManagerRoute } = await import(
        "@src/features/eventsManager/EventsManager.route"
      );
      return {
        element: (
          <ScopedRoute
            debugId={GENERAL_ROUTES.EventsManager}
            isEnabled={(org) => true}
            adminOnly={true}
            children={EventsManagerRoute}
          />
        ),
      };
    },
  },
  {
    path: GENERAL_ROUTES.Offers,
    lazy: async () => {
      const { OffersRoute } = await import("@src/features/offers/Offers.route");
      return {
        element: (
          <ScopedRoute
            debugId={GENERAL_ROUTES.Offers}
            isEnabled={(org) => true}
            adminOnly={true}
            children={OffersRoute}
          />
        ),
      };
    },
  },
  {
    path: GENERAL_ROUTES.SitewideAnalytics,
    lazy: async () => {
      const { SitewideAnalyticsRoute } = await import(
        "@src/features/analytics/sitewideAnalytics/SitewideAnalytics.route"
      );
      return {
        element: (
          <ScopedRoute
            debugId={GENERAL_ROUTES.SitewideAnalytics}
            isEnabled={(org) => true}
            adminOnly={true}
            children={SitewideAnalyticsRoute}
          />
        ),
      };
    },
  },
];
